var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * API service for vocabulary list + CRUD operations.
 * The /vocabularies endpoint restricts results to VOCABULARY_* types on the server side
 * (see VocabularyServiceImpl.buildSpecification in mod-czna-authorities).
 */
import { getHeaders } from './apiUtils';
import { API_PATHS, CZNA_AUTHORITIES_VOCABULARY_DETAIL, CZNA_AUTHORITIES_VOCABULARY_SIMILAR, CZNA_AUTHORITIES_VOCABULARY_TYPE_DETAIL, } from '../types/apiPaths';
import { parseBlockingRefsError } from '../utils/parseBlockingRefsError';
/**
 * Fetches vocabulary terms. The endpoint returns only VOCABULARY_* types,
 * even when `type` is not specified (unlike the records API).
 */
export var fetchVocabularies = function (ky_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([ky_1], args_1, true), void 0, function (ky, params) {
        var searchParams;
        if (params === void 0) { params = {}; }
        return __generator(this, function (_a) {
            searchParams = new URLSearchParams();
            if (params.type)
                searchParams.set('type', params.type);
            if (params.query)
                searchParams.set('query', params.query);
            if (params.sortBy)
                searchParams.set('sortBy', params.sortBy);
            if (params.sortOrder)
                searchParams.set('sortOrder', params.sortOrder);
            if (params.limit !== undefined && params.limit !== null) {
                searchParams.set('limit', params.limit.toString());
            }
            if (params.offset !== undefined && params.offset !== null) {
                searchParams.set('offset', params.offset.toString());
            }
            return [2 /*return*/, ky.get("".concat(API_PATHS.CZNA_AUTHORITIES_VOCABULARIES, "?").concat(searchParams), {
                    headers: getHeaders(),
                }).json()];
        });
    });
};
/**
 * Fetches a single vocabulary term by id (TASK-071, used by the advanced edit pane).
 */
export var fetchVocabulary = function (ky, id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.get(CZNA_AUTHORITIES_VOCABULARY_DETAIL(id), {
                headers: getHeaders(),
            }).json()];
    });
}); };
/**
 * CZNA-1346 — terms and unlinked corpus values that differ from `value` only in punctuation
 * or letter case, for the warning the create dialog shows before it posts.
 */
export var fetchSimilarSpellings = function (ky, type, value) { return __awaiter(void 0, void 0, void 0, function () {
    var searchParams;
    return __generator(this, function (_a) {
        searchParams = new URLSearchParams({ value: value });
        return [2 /*return*/, ky.get("".concat(CZNA_AUTHORITIES_VOCABULARY_SIMILAR(type), "?").concat(searchParams), {
                headers: getHeaders(),
            }).json()];
    });
}); };
/**
 * Creates a new vocabulary term.
 */
export var createVocabulary = function (ky, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.post(API_PATHS.CZNA_AUTHORITIES_VOCABULARIES, {
                json: data,
                headers: getHeaders(),
            }).json()];
    });
}); };
/**
 * Updates an existing vocabulary term.
 */
export var updateVocabulary = function (ky, id, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.put(CZNA_AUTHORITIES_VOCABULARY_DETAIL(id), {
                json: data,
                headers: getHeaders(),
            }).json()];
    });
}); };
/**
 * Archives (soft delete) a vocabulary term.
 *
 * <p>TASK-084 — the backend now enforces the global delete-with-refs invariant.
 * On 409, the rejection comes with a structured BLOCKING_REFERENCES_EXIST payload;
 * we surface it via {@link BlockingRefsError} so the UI dialog can render the refs
 * list + offer redirect as alternative.
 */
export var deleteVocabulary = function (ky, id) { return __awaiter(void 0, void 0, void 0, function () {
    var error_1, blocked;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 4]);
                return [4 /*yield*/, ky.delete(CZNA_AUTHORITIES_VOCABULARY_DETAIL(id), {
                        headers: getHeaders(),
                    }).json()];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                error_1 = _a.sent();
                return [4 /*yield*/, parseBlockingRefsError(error_1)];
            case 3:
                blocked = _a.sent();
                if (blocked) {
                    throw blocked;
                }
                throw error_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * CZNA-312 — fetches the vocabulary-type registry (code, labels, validationType,
 * bibframeRole, optional bindings). Replaces the FE de-enumeration of CLOSED
 * vocab types; the admin GUI reads the catalog from the backend instead of a
 * hardcoded enum + maps.
 */
export var fetchVocabularyTypes = function (ky_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([ky_1], args_1, true), void 0, function (ky, opts) {
        var searchParams, qs, path;
        if (opts === void 0) { opts = {}; }
        return __generator(this, function (_a) {
            searchParams = new URLSearchParams();
            if (opts.validationType)
                searchParams.set('validationType', opts.validationType);
            if (opts.includeBindings)
                searchParams.set('includeBindings', 'true');
            if (opts.includeTermCounts)
                searchParams.set('includeTermCounts', 'true');
            qs = searchParams.toString();
            path = qs
                ? "".concat(API_PATHS.CZNA_AUTHORITIES_VOCABULARY_TYPES, "?").concat(qs)
                : API_PATHS.CZNA_AUTHORITIES_VOCABULARY_TYPES;
            return [2 /*return*/, ky.get(path, {
                    headers: getHeaders(),
                }).json()];
        });
    });
};
/**
 * CZNA-390 (slice S1) / CZNA-395 — registers a new controlled-vocabulary type
 * in the registry. Backing the inline "create a new vocabulary type"
 * affordance in the derivation-rule picker (`CreateVocabularyTypeModal`).
 */
export var createVocabularyType = function (ky, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.post(API_PATHS.CZNA_AUTHORITIES_VOCABULARY_TYPES, {
                json: data,
                headers: getHeaders(),
            }).json()];
    });
}); };
/**
 * CZNA-1470 — renames a vocabulary type (Nastavení → Slovníky). The PUT is a full
 * replace, so the caller echoes every field it does not change; a stale
 * `expectedUpdatedAt` or a read-only type answers 409.
 */
export var updateVocabularyType = function (ky, id, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky.put(CZNA_AUTHORITIES_VOCABULARY_TYPE_DETAIL(id), {
                json: data,
                headers: getHeaders(),
            }).json()];
    });
}); };
